import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import {CTX_SHOW_SPINNER} from "../../models/api-context-const";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const spinner = inject(NgxSpinnerService);
    const show = req.context.get(CTX_SHOW_SPINNER);

    if (show) spinner.show();
    return next(req).pipe(finalize(() => { if (show) spinner.hide(); }));
};
